<template>
  <div id="editEmployee" class="contenedor">
    <Sidebar></Sidebar>
    <loader :show="show" />
    <v-container
      fluid
      class="base text-center ma-0 px-0 pt-6 pb-0"
      v-if="dataEmpleado"
    >
      <v-row no-gutters class="titulo">Editar Empleado</v-row>

      <v-row no-gutters class="datos">
        <v-col class="py-2 mt-12" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="area">Área</label>
            <select name="select2" id="select2" v-model="dataUser.areaId">
              <option disabled value="0">Selecciona Area/Depto</option>
              <option
                v-for="area in areas"
                :key="area.id"
                v-bind:value="area.id"
              >
                {{ area.nombreArea }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2 mt-12" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="job">Puesto</label>
            <select name="job" id="job" v-model="dataUser.puestoId">
              <option disabled value="0">Selecciona Puesto</option>
              <option v-for="job in jobs" :key="job.id" v-bind:value="job.id">
                {{ job.nombrePuesto }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="sueldo">Sueldo</label>
            <input
              type="text"
              name="sueldo"
              id="sueldo"
              placeholder="Obligatorio"
              class="inputs"
              autocomplete="false"
              v-model="dataUser.sueldo"
              required
              maxlength="5"
              @keypress="isNumber($event)"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="dateAdmission">Fecha de Admisión</label>
            <input
              type="date"
              name="dateAdmission"
              id="dateAdmission"
              placeholder="Obligatorio"
              class="inputs"
              autocomplete="false"
              v-model="dataUser.fechaAdmision"
              required
              maxlength="20"
              @keypress="alfaNumerico($event)"
            />
          </div>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="my-5"
          >Datos Personales</v-col
        >

        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="name">Nombre</label>
            <input
              type="text"
              name="name"
              id="name"
              placeholder="Obligatorio"
              class="inputs"
              autocomplete="false"
              v-model="dataUser.nombre"
              required
              maxlength="20"
              @keypress="alfaNumerico($event)"
              @blur="
                nombreCompuesto();
                answer();
              "
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="surname">Apellido Paterno</label>
            <input
              type="text"
              name="surname"
              id="surname"
              placeholder="Obligatorio"
              class="inputs"
              autocomplete="false"
              v-model="dataUser.apellidoPaterno"
              required
              maxlength="20"
              @keypress="alfaNumerico($event)"
              @blur="
                quitaArticulosPaterno();
                answer();
              "
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="lastName">Apellido Materno</label>
            <input
              type="text"
              name="lastName"
              id="lastName"
              class="inputs"
              autocomplete="false"
              v-model="dataUser.apellidoMaterno"
              required
              maxlength="20"
              @keypress="alfaNumerico($event)"
              @blur="
                quitaArticulosMaterno();
                answer();
              "
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="date">Fecha de Nacimiento</label>
            <input
              type="date"
              name="date"
              id="date"
              placeholder="Obligatorio"
              class="inputs"
              autocomplete="false"
              v-model="dataUser.fechaNacimiento"
              required
              maxlength="20"
              @blur="answer()"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="curp">CURP</label>
            <input
              type="text"
              name="curp"
              id="curp"
              placeholder="Obligatorio"
              class="inputs"
              autocomplete="false"
              required
              v-model="dataUser.curp"
              maxlength="18"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="rfc">RFC</label>
            <input
              type="text"
              name="rfc"
              id="rfc"
              placeholder="Obligatorio"
              class="inputs"
              autocomplete="false"
              v-model="dataUser.rfc"
              required
              maxlength="13"
              @keypress="validaRfc($event)"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="imss">IMSS</label>
            <input
              type="text"
              name="imss"
              id="imss"
              placeholder="Obligatorio"
              class="inputs"
              autocomplete="false"
              v-model="dataUser.nss"
              required
              maxlength="11"
              @keypress="isNumber($event)"
            />
          </div>
        </v-col>
        <v-col cols="12" sm="12" class="mt-11">
          <div class="form-group text-center terminos mt-4">
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="regresar()"
            >
              Regresar
            </button>
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="validacion()"
            >
              Siguiente
            </button>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container
      fluid
      class="base text-center ma-0 px-0 pt-6 pb-0"
      v-if="dataCfdi"
    >
      <v-row no-gutters class="titulo">Datos CFDI</v-row>

      <v-row no-gutters class="datos">
        <v-col class="mt-11 mb-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="typeContract">Tipo de Contrato</label>
            <select
              name="typeContract"
              id="typeContract"
              v-model="dataUser.cfdiEmpleado.contratoId"
            >
              <option selected disabled value="0">Selecciona Contrato</option>
              <option
                v-for="contract in contracts"
                :key="contract.id"
                v-bind:value="contract.id"
              >
                {{ contract.tipoContrato }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col class="mt-11 mb-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="typeDay">Tipo de Jornada</label>
            <select
              name="typeDay"
              id="typeDay"
              v-model="dataUser.cfdiEmpleado.jornadaId"
            >
              <option disabled value="0">Selecciona Jornada</option>
              <option v-for="day in days" :key="day.id" v-bind:value="day.id">
                {{ day.nombreJornada }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="risk">Riesgo del Puesto</label>
            <select
              name="risk"
              id="risk"
              v-model="dataUser.cfdiEmpleado.riesgoId"
            >
              <option disabled value="0">Selecciona Riesgo</option>
              <option
                v-for="risk in risks"
                :key="risk.id"
                v-bind:value="risk.id"
              >
                {{ risk.nombreRiesgo }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="union">Sindicalizado</label>
            <select
              name="union"
              id="union"
              v-model="dataUser.cfdiEmpleado.sindicalizado"
            >
              <option disabled value="0">Selecciona Sindicalizado</option>
              <option selected value="1">Si</option>
              <option value="2">No</option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="regime">Tipo de Régimen</label>
            <select
              name="regime"
              id="regime"
              v-model="dataUser.cfdiEmpleado.regimenId"
            >
              <option disabled value="0">Selecciona Regimen</option>
              <option
                v-for="regime in regimes"
                :key="regime.id"
                v-bind:value="regime.id"
              >
                {{ regime.nombreRegimen }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="periodicity">Periodicidad de pago</label>
            <select
              name="periodicity"
              id="periodicity"
              v-model="dataUser.cfdiEmpleado.periodicidadPagoId"
            >
              <option disabled value="0">Selecciona Periodicidad</option>
              <option
                v-for="periodicity in periodicities"
                :key="periodicity.id"
                v-bind:value="periodicity.id"
              >
                {{ periodicity.nombrePeriodicidad }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="labor">Antiguedad</label>
            <input
              type="text"
              name="labor"
              id="labor"
              placeholder="Obligatorio"
              class="inputs mr-2"
              autocomplete="false"
              v-model="dataUser.cfdiEmpleado.antiguedad"
              required
              maxlength="1"
              @keypress="isNumber($event)"
            />
          </div>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="my-5"
          >Datos Bancarios</v-col
        >

        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="bank">Banco</label>
            <select
              name="banck"
              id="bank"
              v-model="dataUser.datosBancoEmpleado.banco.id"
            >
              <option disabled value="0">Selecciona Banco</option>
              <option
                v-for="bank in banks"
                :key="bank.id"
                v-bind:value="bank.id"
              >
                {{ bank.nombreCorto }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="count">Cuenta</label>
            <input
              type="text"
              name="count"
              id="count"
              placeholder="Obligatorio"
              class="inputs"
              autocomplete="false"
              v-model="dataUser.datosBancoEmpleado.cuenta"
              required
              maxlength="10"
              @keypress="isNumber($event)"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="key">Cuenta clabe</label>
            <input
              type="text"
              name="key"
              id="key"
              placeholder="Obligatorio"
              class="inputs"
              autocomplete="false"
              v-model="dataUser.datosBancoEmpleado.cuentaClabe"
              required
              maxlength="18"
              @keypress="isNumber($event)"
            />
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="nomina">Anticipo de nómina</label>

            <select
              name="nomina"
              id="nomina"
              v-model="dataUser.datosBancoEmpleado.anticipoNomina"
            >
              <option selected disabled value="0">Selecciona anticipo</option>
              <option value="1">Si</option>
              <option value="2">No</option>
            </select>
          </div>
        </v-col>
        <v-col cols="12" sm="12" class="mt-11">
          <div class="form-group text-center terminos mt-4">
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="
                dataCfdi = false;
                dataEmpleado = true;
              "
            >
              Regresar
            </button>
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="validacionCfdi()"
            >
              Guardar
            </button>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!--Error-->
    <v-dialog v-model="error" width="400">
      <v-card>
        <v-card-title class="red white--text">
          <span class="headline">{{ message }}</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-md-center text-sm-center text-lg-center">
            {{ respuesta }}
          </h3>
          <br />
          <ul>
            <li v-for="error in errors" :key="error.name">{{ error }}</li>
          </ul>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" text @click="error = false">Corregir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Validación de datos-->
    <v-dialog v-model="advice" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">{{ message }}</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-md-center text-lg-center text-sm-center">
            {{ respuesta }}
          </h3>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="red" text @click="cancel()">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="guardar()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Confirmación de datos-->
    <v-dialog v-model="confirmation" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">{{ message }}</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-lg-center text-sm-center text-md-center">
            {{ respuesta }}
          </h3>
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="cancel()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import Loader from "@/components/Loader";
export default {
  components: {
    Sidebar,
    Loader,
  },
  data() {
    return {
      stepn: "6-N",
      show: false,
      search: "",
      dialog: false,
      selectedItem: null,
      jobs: [],
      areas: [],
      //Arrays para CFDI
      contracts: [],
      days: [],
      risks: [],
      regimes: [],
      periodicities: [], //Arrays para empleado
      advance: "",
      errors: [],
      error: false,
      respuesta: "",
      dataUser: [],
      user: true,
      dataBank: false,
      dataCfdi: false,
      banks: [],
      titulo: "",
      confirmation: false,
      advice: false,
      errorCurp: false,
      enterprise: 0,
      auxName: "",
      auxSurname: "",
      auxLastName: "",
      dataCfdi: false,
      dataEmpleado: true,
      enterprises: [],
    };
  },
  methods: {
    alfaNumerico: function (evt) {
      var regex = new RegExp("^[a-zA-Z0-9 ]+$"); // Letras y números
      var str = String.fromCharCode(!evt.charCode ? evt.which : evt.charCode);
      if (regex.test(str)) {
        return true;
      }
      evt.preventDefault();
      return false;
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if ((charCode > 31 && charCode < 48) || charCode > 57) {
        evt.preventDefault();
      } else return true;
    },
    nombre() {
      localStorage.stepn = this.stepn;
    },
    validacion() {
      console.log("ID DE LA EMPRESA ES: " + this.enterprise);
      this.errors = [];
      this.validaCurp();
      this.validaRfc();
      this.validaImss();
      this.message = "Datos de Empleado";
      if (this.dataUser.nombre == "" || this.dataUser.nombre == " ") {
        this.errors.push("Se debe especificar el nombre del empleado.");
      }
      if (this.dataUser.apellidoPaterno == "" || this.apellidoPaterno == " ") {
        this.errors.push("Se debe especificar el apellido paterno.");
      }
      if (this.dataUser.fechaNacimiento == "") {
        this.errors.push("Se debe especificar la fecha de nacimiento.");
      }
      if (this.dataUser.job == 0 || this.dataUser.job == "") {
        this.errors.push("Se debe especificar el puesto.");
      }
      if (this.area == "" || this.area == 0) {
        this.errors.push("Se debe especificar el area.");
      }
      if (this.dateAdmission == "") {
        this.errors.push("Se debe especificar la fecha de admisión.");
      }
      if (this.pay == "" && this.pay == 0) {
        this.errors.push("Se debe especificar el sueldo.");
      }
      if (this.errors.length == 0) {
        //this.dataEmpleado = false;
        //this.dataCfdi = true;
        this.message = "Alerta";
        this.respuesta = "Esta seguro de la almacenar el empleado.";
        this.advice = true;
      } else {
        this.respuesta = "Por favor corrige el siguiente error:";
        this.error = true;
      }
    },
    validaCount() {
      console.log(this.dataUser.datosBancoEmpleado.cuenta);
      var count = this.dataUser.datosBancoEmpleado.cuenta;
      if (count.length != 10) {
        this.errors.push("Número de Cuenta incorrecto");
        return false;
      } else {
        console.log("Correcto");
        console.log(count.length);
        return false;
      }
    },
    validaKey() {
      console.log(this.dataUser.datosBancoEmpleado.cuentaClabe);
      var key = this.dataUser.datosBancoEmpleado.cuentaClabe;
      if (key.length === 18) {
        return true;
      } else {
        this.errors.push("Número de Cuenta Clabe incorrecto.");
        return false;
      }
    },
    validaCurp() {
      var strCorrecta = this.dataUser.curp;
      if (strCorrecta.length === 18) {
        return true;
      } else {
        this.errors.push("El CURP esta incompleto favor de verificarlo.");
        return false;
      }
    },
    validaRfc() {
      var strCorrecta;
      strCorrecta = this.dataUser.rfc;
      if (this.dataUser.rfc.length == 12) {
        var valid = "^(([A-Z]|[a-z]){3})([0-9]{6})((([A-Z]|[a-z]|[0-9]){3}))";
      } else {
        var valid =
          "^(([A-Z]|[a-z]|s){1})(([A-Z]|[a-z]){3})([0-9]{6})((([A-Z]|[a-z]|[0-9]){3}))";
      }
      var validRfc = new RegExp(valid);
      var matchArray = strCorrecta.match(validRfc);
      if (matchArray == null) {
        this.errors.push("El RFC es incorrecto favor de verificarlo.");
        return false;
      } else {
        console.log("Correcto");
        return true;
      }
    },
    validaImss() {
      console.log("llegue a nss" + this.dataUser.nss);
      if (this.dataUser.nss.length == 11) {
        return false;
      } else {
        this.errors.push("Número de IMSS incorrecto");
        return false;
      }
    },
    quitaArticulos(nombre) {
      this.auxName = nombre;
      console.log("quitar ARTICULOS nombre compuesto" + this.auxName);
      this.auxName = this.auxName
        .replace("LA ", "")
        .replace("DE ", "")
        .replace("SA DE CV", "")
        .replace("LOS ", "")
        .replace("LAS ", "")
        .replace("Y ", "")
        .replace("MC ", "")
        .replace("SA ", "")
        .replace("VON ", "")
        .replace("CIA ", "")
        .replace("DEL ", "")
        .replace("SOC ", "")
        .replace("COOP ", "")
        .replace("A EN P ", "")
        .replace("MAC ", "")
        .replace("S EN C ", "")
        .replace("VAN ", "")
        .replace("EN ", "")
        .replace("MI ", "")
        .replace("CON ", "")
        .replace("SUS ", "")
        .replace("SC ", "")
        .replace("SCS ", "")
        .replace("THE ", "")
        .replace("AND ", "")
        .replace("CO ", "")
        .replace("A ", "")
        .replace("SA DE CV MI ", "")
        .replace("COMPA&ÍA ", "")
        .replace("SRL MI", "");
      console.log("sin articulos" + this.auxName);
      return this.auxName;
    },

    quitaArticulosPaterno() {
      this.auxSurname = this.dataUser.apellidoPaterno.toUpperCase();
      console.log("quitar ARTICULOS apellido Paterno" + this.auxSurname);
      this.auxSurname = this.auxSurname
        .replace("LA ", "")
        .replace("DE ", "")
        .replace("SA DE CV", "")
        .replace("LOS ", "")
        .replace("LAS ", "")
        .replace("Y ", "")
        .replace("MC ", "")
        .replace("SA ", "")
        .replace("VON ", "")
        .replace("CIA ", "")
        .replace("DEL ", "")
        .replace("SOC ", "")
        .replace("COOP ", "")
        .replace("A EN P ", "")
        .replace("MAC ", "")
        .replace("S EN C ", "")
        .replace("VAN ", "")
        .replace("EN ", "")
        .replace("MI ", "")
        .replace("CON ", "")
        .replace("SUS ", "")
        .replace("SC ", "")
        .replace("SCS ", "")
        .replace("THE ", "")
        .replace("AND ", "")
        .replace("CO ", "")
        .replace("A ", "")
        .replace("SA DE CV MI ", "")
        .replace("COMPA&ÍA ", "")
        .replace("SRL MI", "");
      console.log("sin articulos" + this.auxSurname);
      return this.auxSurname;
    },
    quitaArticulosMaterno() {
      this.auxLastName = this.dataUser.apellidoMaterno.toUpperCase();
      console.log("quitar ARTICULOS apellido Materno" + this.auxSurname);
      this.auxLastName = this.auxLastName
        .replace("LA ", "")
        .replace("DE ", "")
        .replace("SA DE CV", "")
        .replace("LOS ", "")
        .replace("LAS ", "")
        .replace("Y ", "")
        .replace("MC ", "")
        .replace("SA ", "")
        .replace("VON ", "")
        .replace("CIA ", "")
        .replace("DEL ", "")
        .replace("SOC ", "")
        .replace("COOP ", "")
        .replace("A EN P ", "")
        .replace("MAC ", "")
        .replace("S EN C ", "")
        .replace("VAN ", "")
        .replace("EN ", "")
        .replace("MI ", "")
        .replace("CON ", "")
        .replace("SUS ", "")
        .replace("SC ", "")
        .replace("SCS ", "")
        .replace("THE ", "")
        .replace("AND ", "")
        .replace("CO ", "")
        .replace("A ", "")
        .replace("SA DE CV MI ", "")
        .replace("COMPA&ÍA ", "")
        .replace("SRL MI", "");
      console.log("sin articulos" + this.auxLastName);
      return this.auxLastName;
    },
    vocales(letra) {
      if (
        letra == "A" ||
        letra == "E" ||
        letra == "I" ||
        letra == "O" ||
        letra == "U" ||
        letra == "a" ||
        letra == "e" ||
        letra == "i" ||
        letra == "o" ||
        letra == "u"
      )
        return true;
      else return false;
    },
    palabraInconveniente(palabra) {
      palabra = palabra
        .replace("BUEI", "BUEX")
        .replace("KOGE", "KOGX")
        .replace("BUEY", "BUEX")
        .replace("KOJO", "KOJX")
        .replace("CACA", "CACX")
        .replace("KAKA", "KAKX")
        .replace("CACO", "CACX")
        .replace("KULO", "KULX")
        .replace("CAGA", "CAGX")
        .replace("MAME", "MAMX")
        .replace("CAGO", "CAGX")
        .replace("MAMO", "MAMX")
        .replace("CAKA", "CAKX")
        .replace("MEAR", "MEAX")
        .replace("COGE", "COGX")
        .replace("MEON", "MEOX")
        .replace("COJA", "COJX")
        .replace("MION", "MIOX")
        .replace("COJE", "COJX")
        .replace("MOCO", "MOCX")
        .replace("COJI", "COJX")
        .replace("MULA", "MULX")
        .replace("COJO", "COJX")
        .replace("PEDA", "PEDX")
        .replace("CULO", "CULX")
        .replace("PEDO", "PEDX")
        .replace("FETO", "FETX")
        .replace("PENE", "PENX")
        .replace("GUEY", "GUEX")
        .replace("PUTA", "PUTX")
        .replace("JOTO", "JOTX")
        .replace("PUTO", "PUTX")
        .replace("KACA", "KACX")
        .replace("QULO", "QULX")
        .replace("KACO", "KACX")
        .replace("RATA", "RATX")
        .replace("KAGA", "KAGX")
        .replace("RUIN", "RUIX")
        .replace("KAGO", "KAGX");
      return palabra;
    },
    anexo1(letra) {
      letra = letra.toUpperCase();
      letra = letra
        .replace(" ", "00")
        .replace("0", "00")
        .replace("1", "01")
        .replace("2", "02")
        .replace("3", "03")
        .replace("4", "04")
        .replace("5", "05")
        .replace("6", "06")
        .replace("7", "07")
        .replace("8", "08")
        .replace("9", "09")
        .replace("&", "10")
        .replace("A", "11")
        .replace("B", "12")
        .replace("C", "13")
        .replace("D", "14")
        .replace("E", "15")
        .replace("F", "16")
        .replace("G", "17")
        .replace("H", "18")
        .replace("I", "19")
        .replace("J", "21")
        .replace("K", "22")
        .replace("L", "23")
        .replace("M", "24")
        .replace("N", "25")
        .replace("O", "26")
        .replace("P", "27")
        .replace("Q", "28")
        .replace("R", "29")
        .replace("S", "32")
        .replace("T", "33")
        .replace("U", "34")
        .replace("V", "35")
        .replace("W", "36")
        .replace("X", "37")
        .replace("Y", "38")
        .replace("Z", "39")
        .replace("Ñ", "40");
      return letra;
    },
    nombreCompuesto() {
      console.log("LLEGA DIRECTO" + this.dataUser.nombre);
      let aux = this.dataUser.nombre.toUpperCase();
      aux = aux.replace("MARIA ", "").replace("JOSE ", "");
      console.log("NOMBRE COMPUESTO" + aux);
      return this.quitaArticulos(aux);
    },
    answer() {
      this.dataUser.rfc = "";
      if (this.auxSurname == "") {
        this.dataUser.rfc += this.auxLastName.substr(0, 1);
        var l = this.auxLastName.length;
        var c;
        if (l > 1) {
          for (var i = 1; i < l; i++) {
            c = this.auxLastName.charAt(i);
            if (this.vocales(c)) {
              this.dataUser.rfc += c;
              break;
            }
          }
          this.dataUser.rfc += this.auxName.substr(0, 2);
        } else {
          c = "X";
          this.dataUser.rfc += c;
          this.dataUser.rfc += this.auxName.substr(0, 2);
        }
      } else if (this.auxLastName == "") {
        this.dataUser.rfc += this.auxSurname.substr(0, 1);
        var l = this.auxSurname.length;
        var c;
        if (l > 1) {
          for (var i = 1; i < l; i++) {
            c = this.auxSurname.charAt(i);
            if (this.vocales(c)) {
              this.dataUser.rfc += c;
              break;
            }
          }
          // rfc += apellidoMaterno.substr(0, 1);
          this.dataUser.rfc += this.auxName.substr(0, 2);
        } else {
          c = "X";
          this.dataUser.rfc += c;
          this.dataUser.rfc += this.auxName.substr(0, 2);
        }
      } else {
        this.dataUser.rfc += this.auxSurname.substr(0, 1);
        var l = this.auxSurname.length;
        var c;
        if (l > 1) {
          for (var i = 1; i < l; i++) {
            c = this.auxSurname.charAt(i);
            if (this.vocales(c)) {
              this.dataUser.rfc += c;
              break;
            }
          }
          this.dataUser.rfc += this.auxLastName.substr(0, 1);
          this.dataUser.rfc += this.auxName.substr(0, 1);
        } else {
          this.dataUser.rfc += this.auxLastName.substr(0, 1);
          this.dataUser.rfc += this.auxName.substr(0, 2);
        }
      }
      this.dataUser.rfc += this.dataUser.fechaNacimiento.substr(2, 2);
      this.dataUser.rfc += this.dataUser.fechaNacimiento.substr(5, 2);
      this.dataUser.rfc += this.dataUser.fechaNacimiento.substr(8, 2);
      this.dataUser.rfc = this.palabraInconveniente(this.dataUser.rfc);
      this.dataUser.curp = this.dataUser.rfc;
      console.log("RFC CREADO" + this.dataUser.rfc);
    },
    listar() {
      this.show = true;
      axios
        .get(Server + "/empresas")
        .then((response) => {
          this.show = false;
          this.enterprises = response.data;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
        });
    },
    listaPeriodicidad() {
      this.show = true;
      axios
        .get(Server + "/periodicidadesPago")
        .then((response) => {
          this.show = false;
          this.periodicities = response.data;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
        });
    },
    listaRegimen() {
      this.show = true;
      axios
        .get(Server + "/regimen")
        .then((response) => {
          this.show = false;
          this.regimes = response.data;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
        });
    },
    regresar() {
      localStorage.employeeNumber = "";
      this.$router.push("/employeesList");
    },
    obtenerAreasPuestos() {
      this.areas = [];
      this.show = true;
      axios
        .get(Server + "/areas")
        .then((response) => {
          this.show = false;
          var auxAreas = response.data;
          auxAreas.forEach((value, index) => {
            if (value.empresaId == this.enterprise) {
              this.areas.push({
                id: value.id,
                nombreArea: value.nombreArea,
              });
            }
          });
        })
        .catch((e) => {
          //console.log(e);
          this.show = false;
        });

      this.jobs = [];
      this.show = true;
      axios
        .get(Server + "/puestos")
        .then((response) => {
          this.show = false;
          var auxAreas = response.data;
          auxAreas.forEach((value, index) => {
            if (value.empresaId == this.enterprise) {
              this.jobs.push({
                id: value.id,
                nombrePuesto: value.nombrePuesto,
              });
            }
          });
        })
        .catch((e) => {
          //console.log(e);
          this.show = false;
        });
    },
    listarBancos() {
      this.show = true;
      axios
        .get(Server + "/bancos")
        .then((response) => {
          this.show = false;
          this.banks = response.data;
        })
        .catch((e) => {
          this.show = false;
          console.log(e);
        });
    },
    listarContratos() {
      this.show = true;
      axios
        .get(Server + "/contratos")
        .then((response) => {
          this.show = false;
          this.contracts = response.data;
        })
        .catch((e) => {
          this.show = false;
          console.log(e);
        });
    },
    listarJornadas() {
      this.show = true;
      axios
        .get(Server + "/jornadas")
        .then((response) => {
          this.show = false;
          this.days = response.data;
        })
        .catch((e) => {
          this.show = false;
          console.log(e);
        });
      this.show = true;
      axios
        .get(Server + "/riesgosPuesto")
        .then((response) => {
          this.show = false;
          this.risks = response.data;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
        });
    },
    format_date(fecha1, fecha2) {
      console.log("fecha pasada" + fecha1);
      var aux = fecha1.substr(0, 10);
      console.log("fecha obtenida" + aux);
      var aux2 = fecha2.substr(0, 10);
      this.dataUser.fechaNacimiento = aux;
      this.dataUser.fechaAdmision = aux2;
      return true;
    },
    validacionCfdi() {
      this.errors = [];
      this.message = "CFDI";
      if (this.labor == "" || this.labor == " ") {
        this.errors.push("Se debe especificar la antigüedad.");
      }
      if (this.contract == "" || this.contract == 0) {
        this.errors.push("Se debe especificar el tipo de contrato.");
      }
      if (this.day == "" || this.day == 0) {
        this.errors.push("Se debe especificar el tipo de jornada.");
      }
      if (this.risk == "" || this.risk == 0) {
        this.errors.push("Se debe especificar el riesgo del puesto.");
      }
      if (this.union == "" || this.union == 0) {
        this.errors.push("Se debe especificar el sindicato.");
      }
      if (this.regime == 0 || this.regime == "") {
        this.errors.push("Se debe especificar el régimen.");
      }
      if (this.periodicity == "" || this.periodicity == 0) {
        this.errors.push("Se debe especificar la periodicidad del pago.");
      }
      this.validaCount();
      this.validaKey();
      if (this.bank == 0 || this.bank == "") {
        this.errors.push("Se debe especificar el Banco.");
      }
      if (this.nomina == 0 || this.nomina == "") {
        this.errors.push("Se debe especificar el anticipo.");
      }
      if (this.errors.length == 0) {
        this.message = "Alerta";
        this.respuesta = "¿Desea actualizar los datos del empleado?";
        this.advice = true;
      } else {
        this.respuesta = "Por favor corrige el siguiente error:";
        this.error = true;
      }
    },
    cancel() {
      this.confirmation = false;
      this.dataUser = [];
      localStorage.employeeNumber = "";
      this.$router.push("/employeesList");
    },
    guardar() {
      this.advice = false;
      this.show = true;
      axios
        .put(Server + "/empleados/instalador/" + this.dataUser.id, {
          EmpresaId: this.enterprise,
          Nombre: this.dataUser.nombre,
          ApellidoPaterno: this.dataUser.apellidoPaterno,
          ApellidoMaterno: this.dataUser.apellidoMaterno,
          FechaNacimiento: this.dataUser.fechaNacimiento,
          CURP: this.dataUser.curp,
          RFC: this.dataUser.rfc,
          NSS: this.dataUser.nss,
          PuestoId: this.dataUser.puestoId,
          AreaId: this.dataUser.areaId,
          FechaAdmision: this.dataUser.fechaAdmision,
          Sueldo: parseFloat(this.dataUser.sueldo),
        })
        .then((response) => {
          this.show = false;
          this.enterprise = "";
          this.message = "Confirmación";
          this.respuesta = "El Empleado fue actualizado con éxito";
          this.confirmation = true;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
          this.enterprise = "";
          this.message = "Aviso";
          this.respuesta = "El Empleado no fue actualizado.";
          this.confirmation = true;
        });
    },
    aux() {
      this.confirmation = false;
      this.$router.push("/employeesList");
    },
    recuperar() {
      this.show = true;
      axios
        .get(Server + "/empleados/" + localStorage.employeeNumber)
        .then((response) => {
          this.show = false;
          this.dataUser = response.data;
          localStorage.employeeNumber = "";
          this.enterprise = this.dataUser.empresaId;
          this.format_date(
            this.dataUser.fechaNacimiento,
            this.dataUser.fechaAdmision
          );
          this.obtenerAreasPuestos();
          if (this.dataUser.cfdiEmpleado.sindicalizado === false) {
            this.dataUser.cfdiEmpleado.sindicalizado = 2;
          } else {
            this.dataUser.cfdiEmpleado.sindicalizado = 1;
          }
          if (this.dataUser.datosBancoEmpleado.anticipoNomina === false) {
            this.dataUser.datosBancoEmpleado.anticipoNomina = 2;
          } else {
            this.dataUser.datosBancoEmpleado.anticipoNomina = 1;
          }
        })
        .catch((e) => {
          this.show = false;
          console.log(e);
        });
    },
  },
  created() {
    this.listarJornadas();
    this.listarContratos();
    this.listaRegimen();
    this.listaPeriodicidad();
    this.recuperar();
    this.listarBancos();
  },
};
</script>
